import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Link, Modal, TextField } from "@mui/material";
import SlidingPanel from "react-sliding-side-panel";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import RKTextField from "../../../Supporting files/RKTextField/RKTextField";
import DatePicker from "../../../Supporting files/DatePicker/DatePicker";
import SelectDropdown from "../../../Supporting files/SelectDropdown/SelectDropdown";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const AddCdBalance: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [uploadFileStep, setUploadFileStep] = React.useState(1);
  const [uploadFile, setUploadFile] = React.useState(false);
  const [addPolicyStatus, setAddPolicyStatus] = React.useState(false);
  const [currentcd, setCurrentCd] = React.useState("");
  const [cdDate, setCdDate] = React.useState<Date | null>(new Date());
  const [cdtime, setCdTime] = React.useState("");
  const [cdamount, setCdAmount] = React.useState("");
  const [paymentmode, setPaymentMode] = React.useState("");
  const [chequenumber, setChequeNumber] = React.useState("");
  const [enterPassword, setEnterPassword] = React.useState("");

  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };

  // const changePageStatus = (status: boolean) => {
  //   if (status === true) {
  //     if (pageStatus < 2) {
  //       setPageStatus(pageStatus + 1);
  //     }
  //   } else {
  //     if (pageStatus > 1) {
  //       setPageStatus(pageStatus - 1);
  //     }
  //   }
  // };

   const payment_data = [
     { key: "Cheque", value: "Cheque" },
     { key: "Cash", value: "Cash" },
     { key: "Cheque", value: "Cheque" },
   ];

  return (
    <SlidingPanel
      type={"right"}
      isOpen={open_status}
      size={75}
      panelClassName="sliding-panel"
      backdropClicked={() => value_update(attrName, false)}
    >
      <div>
        <Grid container spacing={3} alignItems="center">
          <Grid xs={12}>
             {uploadFileStep == 1 ? (
            <h4 className="mb-0 mt-3 text-left">Add CD Balance</h4>) :(
            <h4 className="mb-0 mt-3 text-left">Add CD Balance Confirmation</h4>)}
          </Grid>
          <Grid xs={12} className="mb-4">
            <hr />
          </Grid>
        </Grid>
        <div className="scrollable_area">
          {uploadFileStep == 1 ? (
            <div>
              <Grid
                container
                spacing={3}
                justifyContent="center"
                className="mb-5"
              >
                <Grid xs={12}>
                  <RKTextField
                    class_name="inputField"
                    title="Current CD Balance"
                    value={currentcd}
                    attrName={setCurrentCd}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <DatePicker
                    class_name="inputField"
                    title="Date"
                    value={cdDate}
                    attrName={setCdDate}
                    value_update={updateMasterState}
                    error_message="Please enter Cd Date"
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <RKTextField
                    class_name="inputField"
                    title="Time"
                    value={cdtime}
                    attrName={setCdTime}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={12}>
                  <RKTextField
                    class_name="inputField"
                    title="Add Amount"
                    value={cdamount}
                    attrName={setCdAmount}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={12}>
                  <SelectDropdown
                    class_name="inputField"
                    title="Payment Mode"
                    value={paymentmode}
                    attrName={setPaymentMode}
                    value_update={updateMasterState}
                    dropdown_data={payment_data}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={12}>
                  <RKTextField
                    class_name="inputField"
                    title="Cheque Number"
                    value={chequenumber}
                    attrName={setChequeNumber}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid
                  xs={12}
                  className="ctaBtn"
                  style={{ textAlign: "center" }}
                >
                  <Button
                    variant="contained"
                    className="submitBtn"
                    onClick={() => {
                      setUploadFileStep(2);
                    }}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </div>
          ) : (
            <h1></h1>
          )}
          {uploadFileStep == 2 ? (
            <div>
              <Grid container spacing={3}>
                <Grid xs={12}>
                  <RKTextField
                    class_name="inputField"
                    title="Enter Password"
                    value={enterPassword}
                    attrName={setEnterPassword}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid
                  xs={12}
                  className="ctaBtn"
                  style={{ textAlign: "center" }}
                >
                  <Button
                    variant="contained"
                    className="submitBtn"
                    onClick={() => {
                      setUploadFileStep(3);
                    }}
                  >
                    Confirm
                  </Button>
                </Grid>
              </Grid>
            </div>
          ) : (
            <h1></h1>
          )}
          {uploadFileStep == 3 ? (
            <div>
              <Grid container spacing={3}>
                <Grid xs={12}>
                  <p className="cdbalance_text">
                    CD Balance of ₹ 1,00,000 has been added to the Policy Number
                    1259874563 of Client ID EV43
                  </p>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid
                  xs={12}
                  className="ctaBtn"
                  style={{ textAlign: "center" }}
                >
                  <Button variant="contained" className="submitBtn">
                    Close
                  </Button>
                </Grid>
              </Grid>
            </div>
          ) : (
            <h1></h1>
          )}
        </div>
      </div>
    </SlidingPanel>
  );
};
export default AddCdBalance;
